export default __webpack_public_path__ + "static/collage-1-3d23817d5df9caa837924fbef0b05994.jpg";